import ELEMENT from 'element-ui';
import CommonModules from 'common-modules-zj';

import zhcn from './zh-cn';
import zhtw from './zh-tw';
import usen from './us-en';
import zhcnlicense from './zh-cn-license';
import zhtwlicense from './zh-tw-license';
import usenlicense from './us-en-license';

export default {
  'zh-cn': {
    ...zhcnlicense,
    ...ELEMENT.lang.zhCN,
    ...CommonModules.lang.zhcn,
    ...zhcn,
  },
  'zh-tw': {
    ...zhtwlicense,
    ...ELEMENT.lang.zhTW,
    ...CommonModules.lang.zhtw,
    ...zhtw,
  },
  'us-en': {
    ...usenlicense,
    ...ELEMENT.lang.en,
    ...(CommonModules.lang.usen || {}),
    ...usen,
  },
};



// WEBPACK FOOTER //
// ./src/i18n/index.js